
import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import { Button } from '@/components/ui/button';

interface FullPageLayoutProps {
  children: React.ReactNode;
  showBackButton?: boolean;
  backTo?: string;
  backLabel?: string;
  className?: string;
}

const FullPageLayout: React.FC<FullPageLayoutProps> = ({
  children,
  showBackButton = true,
  backTo = '/',
  backLabel = 'Back to Home',
  className = '',
}) => {
  return (
    <div className={`min-h-screen relative ${className}`}>
      {/* Background gradient */}
      <div className="absolute inset-0 z-[-1] bg-[radial-gradient(circle_at_top_right,theme(colors.primary.DEFAULT/10%),transparent_40%)]"></div>
      
      {/* Back button */}
      {showBackButton && (
        <div className="absolute top-4 left-4 z-10">
          <Button variant="ghost" size="sm" asChild className="gap-1">
            <Link to={backTo}>
              <ArrowLeft className="h-4 w-4" />
              {backLabel}
            </Link>
          </Button>
        </div>
      )}
      
      {/* Content */}
      <div className="w-full h-full">
        {children}
      </div>
    </div>
  );
};

export default FullPageLayout;
